import React from "react";
import SubPageTemplate from "../../components/subpagetemplate";
import { useCategoryOffers } from "../../hooks/useCategoryOffers";
import HelmetSeo from "../../components/HelmetSeo";
import { pageSeoConfig } from "../../config/pageSeo";

const Apparel: React.FC = () => {
  const apparelData = useCategoryOffers("apparel");
  const seoMeta = pageSeoConfig.apparel;

  return (
    <>
      <HelmetSeo title={seoMeta.title} description={seoMeta.description} />
      <SubPageTemplate standard_categories={apparelData} title="Apparel" />
    </>
  );
};

export default Apparel;
